/* eslint-disable no-console */
import moment from "moment";

import instance from "../xhrService";

const baseUrl = "/api/weather";
const getBaseUrl = (a, b) => `${baseUrl}/${a}/${b}`;
const localStorageKey = "weather";

const weatherApi = {
  fetch: (latitude, longitude) => {

    if(navigator.onLine){
    return instance
      .get(getBaseUrl(latitude, longitude))
      .then(({ data }) => {
        if (data && data.name === "Error") {
          weatherApi.store([]);
        } else {
          weatherApi.store(data);
        }

        return data;
      })
      .catch(err => {
        console.log("err getting weather", err);
        weatherApi.clear();

        return "error";
      });
    }
    else {

      return new Promise((resolve, reject) => {
        reject("error");
      })
    }
  },

  index: () => {
    const weatherData = localStorage.getItem(localStorageKey);

    if (!weatherData) return [];

    // wrap in try-catch in case localStorage value gets corrupted
    try {
      const today = moment().format(moment.HTML5_FMT.DATE);
      const weatherDate = localStorage.getItem("weather date")

      if (today === weatherDate) {
        return JSON.parse(weatherData);
      }

      return [];
    } catch (error) {
      weatherApi.clear();

      return [];
    }
  },

  store: data => {
    localStorage.setItem("weather date", moment().format(moment.HTML5_FMT.DATE));
    localStorage.setItem(localStorageKey, JSON.stringify(data));
  },

  clear: () => {
    localStorage.removeItem(localStorageKey);
    localStorage.removeItem("weather date");
  },

  fetchByProjectId: (latitude, longitude, projectId) => {
    return instance
      .get(getBaseUrl(latitude, longitude))
      .then(({ data }) => {
        if (data && data.name === "Error") {
          weatherApi.storeByProjectId([], projectId);
        } else {
          weatherApi.storeByProjectId(data, projectId);
        }

        return data;
      })
      .catch(err => {
        console.log("err getting weather", err);
        weatherApi.clearByProjectId(projectId);

        return "error";
      });
  },

  indexByProjectId: projectId => {
    const weatherData = localStorage.getItem(localStorageKey + projectId);

    if (!weatherData) return [];

    // wrap in try-catch in case localStorage value gets corrupted
    try {
      const today = moment().format(moment.HTML5_FMT.DATE);
      const weatherDate = localStorage.getItem("weather date" + projectId);

      if (today === weatherDate) {
        return JSON.parse(weatherData);
      }

      return [];
    } catch (error) {
      weatherApi.clearByProjectId(projectId);

      return [];
    }
  },

  storeByProjectId: (data, projectId) => {
    localStorage.setItem("weather date" + projectId, moment().format(moment.HTML5_FMT.DATE));
    localStorage.setItem(localStorageKey + projectId, JSON.stringify(data));
  },

  clearByProjectId: projectId => {
    localStorage.removeItem(localStorageKey + projectId);
    localStorage.removeItem("weather date" + projectId);
  },

};

export default weatherApi;
